export default __webpack_public_path__ + "static/media/discoverOppsHeroImg.71f718bd.png";